import React, { useEffect, useState } from 'react';
import styles from './ScrollProgressBar.module.css';

const ScrollProgressBar: React.FC = () => {
  const [scrollPercent, setScrollPercent] = useState<number>(0);

  const handleScroll = () => {
    const scrollTop = window.scrollY;
    const docHeight =
      document.documentElement.scrollHeight - window.innerHeight;

    if (docHeight === 0) {
      setScrollPercent(0);
      return;
    }

    const scrolled = (scrollTop / docHeight) * 100;
    setScrollPercent(scrolled);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.bar} style={{ width: `${scrollPercent}%` }} />
    </div>
  );
};

export default ScrollProgressBar;
